import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAppstore } from "react-icons/io";
import { FaGooglePlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/dotsplosion/01_massive_chain_reactions.png";
import screenshot2 from "../../Assets/Projects/dotsplosion/02_smart_bot_modes.png";
import screenshot3 from "../../Assets/Projects/dotsplosion/03_global_online_matches.png";
import screenshot4 from "../../Assets/Projects/dotsplosion/04_private_friend_rooms.png";
import screenshot5 from "../../Assets/Projects/dotsplosion/05_daily_powerups.png";
import screenshot6 from "../../Assets/Projects/dotsplosion/06_elo_ranked_ladder.png";

const translations = {
  tr: {
    title: "Dotsplosion",
    description: "Zincirleme reaksiyonlarla noktaları patlat! Online rakiplerle veya akıllı botlara karşı oyna. Arkadaş odaları, günlük güçlendirmeler, ELO sıralama sistemi ve küresel liderlik tablosu. iOS ve Android'de ücretsiz.",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "Dotsplosion - Detaylı Bilgi",
    features: [
      "💥 Zincirleme Reaksiyonlar: Devasa patlamalar yaratın",
      "🤖 Akıllı Bot Modları: Farklı zorluk seviyelerinde botlara karşı oynayın",
      "🌍 Online Eşleşme: Küresel oyuncularla gerçek zamanlı maçlar",
      "👥 Arkadaş Odaları: Özel odalar oluşturup arkadaşlarınızla oynayın",
      "⚡ Günlük Güçlendirmeler: Her gün yeni powerup'lar kazanın",
      "🏆 ELO Sıralama: Rekabetçi sıralama sistemi ile yükselişe geçin",
      "📱 iOS ve Android: Her iki platformda da mevcut"
    ]
  },
  en: {
    title: "Dotsplosion",
    description: "Trigger massive chain reactions by exploding dots! Play against online opponents or smart bots. Features friend rooms, daily powerups, ELO ranking system, and global leaderboards. Free on iOS and Android.",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "Dotsplosion - Detailed Information",
    features: [
      "💥 Chain Reactions: Create massive explosions",
      "🤖 Smart Bot Modes: Play against bots at various difficulty levels",
      "🌍 Online Matches: Real-time matches with global players",
      "👥 Friend Rooms: Create private rooms and play with friends",
      "⚡ Daily Powerups: Earn new powerups every day",
      "🏆 ELO Ranked Ladder: Climb the competitive ranking system",
      "📱 iOS & Android: Available on both platforms"
    ]
  }
};

const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6
];

function DotsplosionCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <Button
            variant="primary"
            href="https://apps.apple.com/app/dotsplosion/id_PLACEHOLDER"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <IoIosAppstore /> &nbsp;
            App Store
          </Button>
          <Button
            variant="primary"
            href="https://play.google.com/store/apps/details?id=PLACEHOLDER"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <FaGooglePlay /> &nbsp;
            Google Play
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy/dotsplosion"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/support/dotsplosion"
              size="sm"
              style={{ marginLeft: "5px" }}
            >
              {language === "tr" ? "Destek" : "Support"}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              ✨ {content.modalTitle.split(" - ")[1]}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DotsplosionCard;
